// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__Lx_aC","content":"LayoutSettings_content__3Wrr0"};